import React, { useEffect, useRef } from 'react';
import polyline from '@mapbox/polyline';

const MapPreview = ({ routePolyline, originAddress, destinationAddress }) => {
  const mapContainerRef = useRef(null);
  const mapRef = useRef(null);

  // Giải mã polyline: polyline.decode trả về mảng [[lat, lng], ...] → cần chuyển thành [[lng, lat], ...] cho goongjs
  const decodePolyline = (encoded) => {
    return polyline.decode(encoded).map(([lat, lng]) => [lng, lat]);
  };

  // Khởi tạo map một lần
  useEffect(() => {
    if (!window.goongjs) {
      console.error('goongjs chưa được nhúng. Hãy chèn script CDN vào index.html.');
      return;
    }
    window.goongjs.accessToken =
      process.env.REACT_APP_GOONG_MAP_TILES_KEY || 'pM4TRHbAYk4I8IwnAivYZo8fbBBVcRhM4fir8PFy';
    const map = new window.goongjs.Map({
      container: mapContainerRef.current,
      style: 'https://tiles.goong.io/assets/goong_map_web.json',
      center: [105.8, 21.02],
      zoom: 6,
    });
    mapRef.current = map;
    return () => {
      if (mapRef.current) mapRef.current.remove();
    };
  }, []);

  // Khi routePolyline thay đổi, chờ style load rồi thêm layer route và marker cho điểm đi, điểm đến
  useEffect(() => {
    if (!mapRef.current || !routePolyline) return;
    const map = mapRef.current;
    const coordinates = decodePolyline(routePolyline);
    if (!coordinates || coordinates.length < 2) return;

    const addRouteLayer = () => {
      if (map.getSource('route')) {
        if (map.getLayer('route')) {
          map.removeLayer('route');
        }
        map.removeSource('route');
      }
      map.addSource('route', {
        type: 'geojson',
        data: {
          type: 'Feature',
          geometry: {
            type: 'LineString',
            coordinates: coordinates,
          },
        },
      });
      map.addLayer({
        id: 'route',
        type: 'line',
        source: 'route',
        paint: {
          'line-color': '#FF0000',
          'line-width': 4,
        },
      });
      // Fit map để hiển thị hết route
      const bounds = new window.goongjs.LngLatBounds();
      coordinates.forEach(coord => bounds.extend(coord));
      map.fitBounds(bounds, { padding: 40 });
    };

    const addMarkers = () => {
      // Lấy tọa độ đầu và cuối của route
      const startCoord = coordinates[0];
      const endCoord = coordinates[coordinates.length - 1];

      // Marker cho điểm đi với nhãn là originAddress
      const startEl = document.createElement('div');
      startEl.style.backgroundColor = '#00FF00';
      startEl.style.padding = '4px 8px';
      startEl.style.borderRadius = '4px';
      startEl.style.color = '#000';
      startEl.style.fontSize = '12px';
      startEl.innerText = 'Điểm đi';

      new window.goongjs.Marker(startEl)
        .setLngLat(startCoord)
        .addTo(map);

      // Marker cho điểm đến với nhãn là destinationAddress
      const endEl = document.createElement('div');
      endEl.style.backgroundColor = '#0000FF';
      endEl.style.padding = '4px 8px';
      endEl.style.borderRadius = '4px';
      endEl.style.color = '#fff';
      endEl.style.fontSize = '12px';
      endEl.innerText = 'Điểm đến';

      new window.goongjs.Marker(endEl)
        .setLngLat(endCoord)
        .addTo(map);
    };

    const addEverything = () => {
      addRouteLayer();
      addMarkers();
    };

    if (map.isStyleLoaded()) {
      addEverything();
    } else {
      const onLoad = () => {
        addEverything();
        map.off('load', onLoad);
      };
      map.on('load', onLoad);
    }
  }, [routePolyline, originAddress, destinationAddress]);

  return (
    <div ref={mapContainerRef} style={{ width: '100%', height: '400px' }} />
  );
};

export default MapPreview;
